<div class="row mb-3" *ngIf="!isViewingStore() && isClientDetailView()">
  <div class="col-12">
    <button class="btn btn-sm btn-light-primary" (click)="goBackToHome()">
      <i class="bi bi-arrow-left me-1"></i> Back to Home
    </button>
  </div>
</div>

